import { atom } from "recoil";

export interface AuthState {
  id: string;
  token: string;
  isAuthenticated: boolean;
  refreshTokenExpiration?: string;
  roles: string[];
  email:string
}

const authAtom = atom<AuthState | null>({
  key: "auth",
  default: JSON.parse(localStorage.getItem("user") || "null"),
});

const messageAtom = atom<string>({
  key: "toast",
  default: "",
});

export { authAtom, messageAtom };